import { Component, OnInit } from '@angular/core';
import { CurrentUser } from '@models/Core/CurrentUser';
import { AdminUserRequestService } from '@services/admin/users.request.service';
import { AuthenticationService } from '@services/auth/authentication.service';
import { BusService } from '@services/bus.service';
import { DashboardService } from '@services/dashboard/dashboard.service';
import { EventsService } from '@services/events.service';

@Component({
  selector: 'app-admin-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
})
export class AdminUserListComponent implements OnInit {
  users: CurrentUser[];
  dashboardUrl: string;

  constructor(
    private bus: BusService,
    private events: EventsService,
    private adminUser: AdminUserRequestService,
    private auth: AuthenticationService,
    private dashboard: DashboardService,
  ) {
    this.dashboard.url.subscribe(url => (this.dashboardUrl = url));
  }

  usersReceive(users: CurrentUser[]) {
    this.users = users;
  }

  usersFailure(error) {
    console.error(error);
  }

  get isAdmin() {
    return this.auth.isAdmin;
  }

  delete(user: CurrentUser) {
    this.bus.publish(this.events.requested.action.user.delete, user);
    this.users.splice(this.users.indexOf(user), 1);
  }

  ngOnInit() {
    this.bus.subscribe(
      this.events.received.data.user.all.success,
      this.usersReceive.bind(this),
    );
    this.bus.subscribe(
      this.events.received.data.user.all.failure,
      this.usersFailure.bind(this),
    );
    this.bus.publish(this.events.requested.data.user.all);
  }
}
